module.exports = __webpack_public_path__ + "img/pricingformula.57ca0c9b.png";